var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11875 10.8004V8.40039C6.11875 6.80909 6.75089 5.28297 7.87611 4.15775C9.00133 3.03253 10.5275 2.40039 12.1187 2.40039C13.71 2.40039 15.2362 3.03253 16.3614 4.15775C17.4866 5.28297 18.1187 6.80909 18.1187 8.40039V10.8004C18.7553 10.8004 19.3657 11.0532 19.8158 11.5033C20.2659 11.9534 20.5187 12.5639 20.5187 13.2004V19.2004C20.5187 19.8369 20.2659 20.4474 19.8158 20.8974C19.3657 21.3475 18.7553 21.6004 18.1187 21.6004H6.11875C5.48223 21.6004 4.87178 21.3475 4.42169 20.8974C3.97161 20.4474 3.71875 19.8369 3.71875 19.2004V13.2004C3.71875 12.5639 3.97161 11.9534 4.42169 11.5033C4.87178 11.0532 5.48223 10.8004 6.11875 10.8004ZM15.7187 8.40039V10.8004H8.51875V8.40039C8.51875 7.44561 8.89803 6.52994 9.57317 5.85481C10.2483 5.17968 11.164 4.80039 12.1187 4.80039C13.0735 4.80039 13.9892 5.17968 14.6643 5.85481C15.3395 6.52994 15.7187 7.44561 15.7187 8.40039Z",
    fill: "#565556"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.4ec89e95083025aea0f453029d8617e9.svg";
export { ForwardRef as ReactComponent };